__webpack_require__.p = "/gh/investment/funds/";